const Objects = {
    sortByKey: function (object) {
        return Object.keys(object)
            .sort((a, b) => a.localeCompare(b))
            .reduce((r, k) => {
                r[k] = object[k];
                return r;
            }, {});
    },
    isJson: function (object) {
        try {
            JSON.parse(object);
        } catch (e) {
            console.error(e);
            return false;
        }
        return true;
    },
    parseJson: function (object) {
        try {
            const test = JSON.parse(object);
            if (test && typeof test === "object") {
                return test;
            }
        } catch (e) {
            console.error(e);
            return null;
        }
        return null;
    },
};

export default Objects;

export const cleanObject = (obj) => {
    for (let propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
};
